export default __webpack_public_path__ + "static/media/alientechnology_clear.52023b24.png";